import {
  EnvironmentType,
  ILogger,
  getInstanceInfo,
  useLogger,
  useSharedState,
} from '@deliveryhero/vendor-web-core';
import {useEffect, useState} from 'react';
import {STG_API_GATEWAY_URL} from '../configs/config.stg';
import {PROD_DISCOVERY_CONFIG} from '../configs/discovery.prod';
import {AUTH_STATE, AuthStateSlice, User} from '../interfaces/AuthState';

const useCountry = (): string | undefined => {
  const user = useSharedState<User | null | undefined>(
    (state: {[AUTH_STATE]?: AuthStateSlice}) => state[AUTH_STATE]?.user as User | null | undefined,
  );
  const firstGeId = useSharedState<string | undefined>(
    (state) =>
      ((state[AUTH_STATE] as AuthStateSlice | undefined)?.accounts ?? [])[0]?.global_entity_id,
  );
  const [country, setCountry] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (user === null || user === undefined) {
      setCountry(undefined);
      return;
    }
    const userCountry = user.country?.toLowerCase();
    if (userCountry === undefined || userCountry === '') {
      const countryFromGeid = firstGeId?.split('_')[1]?.toLowerCase();
      setCountry(countryFromGeid);
      return;
    }

    setCountry(userCountry);
  }, [user, firstGeId]);

  return country;
};

const getProdApiGatewayUrl = (country: string | undefined, logger: ILogger): string | undefined => {
  if (country === undefined) {
    return undefined;
  }
  const instance = PROD_DISCOVERY_CONFIG.config[country];
  const apiGatewayUrl = PROD_DISCOVERY_CONFIG.rpsInstance[instance]?.crs;

  if (apiGatewayUrl === undefined) {
    logger.error(
      'Availability: getProdApiGatewayUrl: no apiGatewayUrl known for the given country and instance',
      {},
      {country, instance},
    );
    return undefined;
  }
  return apiGatewayUrl;
};

export const useApiGatewayUrl = (): string | undefined => {
  const {environmentType} = getInstanceInfo();
  const logger = useLogger();
  const country = useCountry();

  switch (environmentType) {
    case EnvironmentType.Local:
    case EnvironmentType.Staging:
      return STG_API_GATEWAY_URL;
    case EnvironmentType.Production:
      return getProdApiGatewayUrl(country, logger);
    default: {
      logger.error(
        'Availability: useApiGatewayUrl: environmentType is not known',
        {},
        {environmentType},
      );
      return undefined;
    }
  }
};
